import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Main from "./Main";
import { FaroErrorBoundary, faro } from "@grafana/faro-react"; // Import Faro components

import "helpers/initFA";

const container = document.getElementById("main");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <FaroErrorBoundary faro={faro}>
      <Main>
        <App />
      </Main>
    </FaroErrorBoundary>
  </React.StrictMode>
);
